import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"cl-elevation rounded-xl d-flex flex-column justify-center align-center pa-4 overflow-hidden text-center",attrs:{"height":"100%","to":_vm.payload.to}},[_c(VCardTitle,{staticClass:"mb-1"},[_c(VIcon,{attrs:{"color":_vm.isActive ? 'blue' : '',"x-large":""}},[_vm._v(_vm._s(_vm.payload.icon))])],1),_c(VCardActions,[_c('header',{staticClass:"grow"},[_c('p',{class:[
          'subtitle-1 font-weight-medium',
          _vm.isActive ? 'blue--text' : '' ]},[_vm._v(" "+_vm._s(_vm.payload.title)+" ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }